import { render, staticRenderFns } from "./ShopCheckout.vue?vue&type=template&id=3cb881af&"
import script from "./ShopCheckout.vue?vue&type=script&lang=js&"
export * from "./ShopCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports